var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable } from "mobx";
import { buildWebsiteUrl, WebsiteURL } from "healthex-common/websiteurls";
import { i18nGetCurrentLanguage } from "../Infra/i18next";
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export class ForgotPasswordViewModel {
    constructor(container) {
        this.email = "";
        this.emailSent = false;
        this.environment = container.environment;
        this.authManager = container.authManager;
    }
    get isEmailValid() {
        return EMAIL_REGEX.test(this.email);
    }
    updateEmail(email) {
        this.email = email;
    }
    async requestPasswordReset() {
        if (this.email) {
            await this.authManager.sendPasswordResetUrl(this.email);
            this.emailSent = true;
        }
    }
    enterNewEmail() {
        this.emailSent = false;
    }
    contactUsToJoin() {
        window.open(buildWebsiteUrl(WebsiteURL.CONTACT_US, this.environment.WEBSITE_BASE_URL, i18nGetCurrentLanguage()));
    }
}
__decorate([
    observable
], ForgotPasswordViewModel.prototype, "email", void 0);
__decorate([
    observable
], ForgotPasswordViewModel.prototype, "emailSent", void 0);
__decorate([
    computed
], ForgotPasswordViewModel.prototype, "isEmailValid", null);
